import { sharedSchema } from "@shared-database/pgSchema";
import { timestampColumns } from "@shared-database/utils";
import { primaryKey, text, timestamp } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import type { z } from "zod";

export const VerificationToken = sharedSchema.table(
  "VerificationToken",
  {
    // Mixins
    ...timestampColumns,

    // Properties
    identifier: text("identifier").notNull(),
    token: text("token").notNull(),
    expires: timestamp("expires", { mode: "date" }).notNull(),
  },
  (vt) => [primaryKey({ columns: [vt.identifier, vt.token] })],
);
export const insertVerificationTokenSchema =
  createInsertSchema(VerificationToken);
export type InsertVerificationTokenType = z.infer<
  typeof insertVerificationTokenSchema
>;
